import React from 'react';

export const CollectiveIndividualPlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-indigo-500 to-purple-600 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">Collective Individual</div>
      <div className="text-lg opacity-80">The future of human-AI relationships</div>
    </div>
  </div>
);

export const EmbodiedAIPlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">Embodied AI</div>
      <div className="text-lg opacity-80">Physical presence in human-computer interaction</div>
    </div>
  </div>
);

export const EthicsAIPlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-emerald-500 to-teal-600 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">AI Ethics</div>
      <div className="text-lg opacity-80">Ethical frameworks for personal AI</div>
    </div>
  </div>
);

export const RoboticsPlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-orange-500 to-amber-500 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">Robotics & AI</div>
      <div className="text-lg opacity-80">Engineering the physical form</div>
    </div>
  </div>
);

export const HealthcarePlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-rose-500 to-pink-600 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">AI in Healthcare</div>
      <div className="text-lg opacity-80">Supporting health & wellbeing</div>
    </div>
  </div>
);

export const UIDesignPlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-violet-500 to-purple-600 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">UI Design for AI</div>
      <div className="text-lg opacity-80">Creating interfaces that foster trust</div>
    </div>
  </div>
);

export const PrivacyPlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-slate-600 to-slate-800 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">Privacy in AI</div>
      <div className="text-lg opacity-80">Protecting personal data</div>
    </div>
  </div>
);

export const CloudProcessingPlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-sky-500 to-blue-600 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">Cloud Processing</div>
      <div className="text-lg opacity-80">Balancing capability and privacy</div>
    </div>
  </div>
);

export const SpatialAIPlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-green-500 to-emerald-600 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">Spatial Intelligence</div>
      <div className="text-lg opacity-80">AI that understands physical space</div>
    </div>
  </div>
);

export const SocialAIPlaceholder = () => (
  <div className="w-full h-full bg-gradient-to-r from-red-500 to-rose-600 flex items-center justify-center">
    <div className="text-white text-center p-4">
      <div className="text-3xl font-semibold mb-2">Social Intelligence</div>
      <div className="text-lg opacity-80">AI that understands human dynamics</div>
    </div>
  </div>
);
